"use client";

import React from "react";
import { LocaleLink as Link } from "@/components/shared/LocaleLink";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal } from "@/components/shared/motion";
import { Plane, MapPin, ArrowRight } from "lucide-react";

/**
 * SkyLane-native CTA band — a full-width solid electric-blue band with a
 * route-dash motif and a white "Browse destinations" button. No glass, no
 * gradients.
 */
export default function CtaBand() {
  const { t } = useTranslations();

  return (
    <section className="container mx-auto px-4 py-12">
      <Reveal as="div" y={20} className="rounded-2xl bg-primary text-primary-foreground p-8 sm:p-10 shadow-md flex flex-col sm:flex-row items-center justify-between gap-6">
        <div>
          {/* Route-dash motif */}
          <div className="flex items-center gap-2 text-primary-foreground/70 mb-3" aria-hidden="true">
            <Plane className="w-5 h-5" />
            <span className="route-dash w-24" />
            <MapPin className="w-5 h-5" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold">
            {t("sky.ctaBand.title", "Ready to travel smarter?")}
          </h2>
          <p className="mt-2 opacity-90">
            {t("sky.ctaBand.sub", "Pick your destination, check out securely, and get your eSIM QR code instantly.")}
          </p>
        </div>
        <Link
          href="/destinations/"
          className="group inline-flex items-center gap-2 rounded-xl bg-card text-foreground font-bold px-6 h-12 shrink-0 hover:bg-card/90 transition-all active:scale-[0.98]"
        >
          {t("sky.ctaBand.cta", "Browse destinations")} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
        </Link>
      </Reveal>
    </section>
  );
}
